module.exports = __webpack_public_path__ + "img/ic_nav_sound-on.b6965084.svg";